const Reflux = require('@muzzylane/reflux');

const ViewStateActions = Reflux.createActions({
    updateViewName: { children: ['completed'] },
});

ViewStateActions.updateViewName.listen(function(viewName) {
    this.completed(viewName);
});

module.exports = ViewStateActions;
